module.exports = __webpack_public_path__ + "static/media/ic sky.7df1f31b.png";